import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

const validator = z.object({
  sha: z.string(),
});

export const buildShaQueryKey = ["__BUILD__"];

export async function fetchBuildSha() {
  const res = await fetch("/build.json", { cache: "no-store" });

  if (!res.ok) {
    throw new Error("Could not find buildSha");
  }

  const json = await res.json();

  return validator.parse(json);
}

export function useBuildSha() {
  return useQuery({
    queryKey: buildShaQueryKey,
    queryFn: fetchBuildSha,
  });
}

export function useShouldReload() {
  const { data, isLoading } = useBuildSha();

  const isShaDifferent =
    !isLoading && data?.sha !== import.meta.env.VITE_BUILD_SHA;
  const isNotLocal = !import.meta.env.DEV;

  const shouldReload = isNotLocal && isShaDifferent;

  const handleReloadClick =
    (originalOnClick?: React.MouseEventHandler<HTMLAnchorElement>) =>
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (shouldReload) {
        console.log("Outdated, reloading the application");

        e.preventDefault();
        window.location.href = e.currentTarget.href;
        return;
      }

      return originalOnClick?.(e);
    };

  return {
    shouldReload,
    handleReloadClick,
  };
}
